import { Flame, Sparkles, Zap } from "lucide-react";
import { scoreMoment, type ViralMomentInput } from "@/lib/viralMomentEngine";

/**
 * Visible badge rendering the Viral Moment Engine output.
 * Slot it inside cinematic cards, capsules, share sheets, etc.
 */
export function ViralPotentialBadge({ input, compact = false }: { input: ViralMomentInput; compact?: boolean }) {
  const s = scoreMoment(input);
  const tone =
    s.sharePotential === "explosive" ? "from-rose-500 to-orange-500 text-white"
    : s.sharePotential === "high" ? "from-orange-400 to-amber-500 text-black"
    : s.sharePotential === "medium" ? "from-amber-300 to-yellow-400 text-black"
    : "from-white/15 to-white/5 text-white/80";
  const Icon = s.sharePotential === "explosive" ? Flame : s.sharePotential === "high" ? Zap : Sparkles;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-gradient-to-r ${tone} ${compact ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]"} font-black uppercase tracking-wider shadow-[0_0_18px_rgba(244,114,55,0.35)]`}
      title={`Viral Score ${s.viralScore} · ${s.recommendedPlatform.toUpperCase()}`}
    >
      <Icon className={compact ? "h-2.5 w-2.5" : "h-3 w-3"} />
      {s.label} <span className="tabular-nums opacity-80">{s.viralScore}</span>
    </span>
  );
}